<template>
	<div id="app">
        <div class="header-main">
            <Header></Header>
        </div>
        <div class="gap"></div>
		<router-view/>
        <transition name="fade"><div class="toTop" v-show='showTop' @click='clickToTop'><img src="./assets/img/toTop.png" alt=""></div></transition>
	</div>
</template>

<script>
import Header from './components/head'
export default {
    components: {
        Header
    },
    data () {
        return {
            showTop: false
        }
    },
    methods: {
        clickToTop(){
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
        scrollToLoad(){
            if(this.getScrollTop() >=100){
                this.showTop = true;
            }else{
                this.showTop = false;
            }
        },
        getScrollTop(){
        　　var scrollTop = 0, bodyScrollTop = 0, documentScrollTop = 0;
        　　if(document.body){
        　　　　bodyScrollTop = document.body.scrollTop;
        　　}
        　　if(document.documentElement){
        　　　　documentScrollTop = document.documentElement.scrollTop;
        　　}
        　　scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
        　　return scrollTop;
        }
    },
    mounted(){
        this.$nextTick(function () {
            window.addEventListener('scroll', this.scrollToLoad)
        })
    }
}
</script>

<style scoped lang='less'>
    .header-main{
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
    }
    .gap{
        height: 70px;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to  {
        opacity: 0;
    }
    .toTop{
        position: fixed;
        bottom: 20px;
        right: 20px;
        width: 40px;
        height: 40px;
        background: #fff;
        border: 1px solid #e6e6e6;
        border-radius: 4px;
        img{
            margin: 8px auto 0;
        }
        box-shadow: 1px 1px 1px 1px #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue